import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-resources-units-anagraf',
  templateUrl: './new-resources-units-anagraf.component.html',
  styleUrls: ['./new-resources-units-anagraf.component.scss']
})
export class NewResourcesUnitsAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  resourceUnit: ResourcesUnitModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private resourceUnitService: ResourceUnitService) {
    super();

    this.resourceUnit = new ResourcesUnitModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.resourceUnit.cod, [Validators.required]],
      name: [this.resourceUnit.name, [Validators.required]],
      offset: [this.resourceUnit.offset]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.resourceUnit.cod = this.formValidator.value.cod;
      this.resourceUnit.name = this.formValidator.value.name;
      this.resourceUnit.offset = this.formValidator.value.offset;
      this.saveSubscribe = this.resourceUnitService.save(this.resourceUnitService.baseUrl, this.resourceUnit).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Resource Unit Cod already exists', 'Warning');
          } else {
            toastr.success('Element added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF]);
          }
        }, error => {
          toastr.error('Element was not added', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
